<template>
  <div class="box">
    <div class="box-zhong">LES物流系统</div>
    <div class="box-right">
      <!--    点击铃铛弹出框-->
      <el-popover placement="bottom" trigger="click">
        <div class="Bell_reminder">
          <div class="bell_left" v-if="flag">
            <el-table :data="leftData" max-height="300">
              <el-table-column prop="Rosy" label="超24小时未揽收运单"></el-table-column>
            </el-table>
          </div>
          <div class="bell-right" v-if="flag">
            <el-table :data="rightData" max-height="300">
              <el-table-column prop="Luo" label="超5天未发货生产单"></el-table-column>
            </el-table>
          </div>
          <div class="bell-right" v-if="flag1">
            <el-table :data="threeData" max-height="300">
              <el-table-column prop="jie" label="超3天未发货生产单"></el-table-column>
            </el-table>
          </div>
        </div>
        <i class="el-icon-message-solid" slot="reference" v-if="show"></i>
<!--        <i class="iconfont icon-xiaoxitixing" slot="reference" v-if="show"></i>-->
      </el-popover>
      <i class="el-icon-s-custom"></i>
      <span class="Hello">您好,{{this.userName}}</span>
      <i class="iconfont icon-tuichu1" @click="tuichu()"></i>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userName:sessionStorage.getItem('userName'),
      leftData:[],
      rightData:[],
      threeData:[],
      timeOne:'',
      //根据session值判断铃铛的显示与隐藏
      show:false,
      flag:false,
      flag1:false,
      //小铃铛请求时给后端返回
      userBell:sessionStorage.getItem('userName'),
      organizationCode:sessionStorage.getItem('organizationCode'),
      carriersBell:sessionStorage.getItem('carriersCode')
    };
  },
  created() {
    if(sessionStorage.getItem('orgType') ==='物流基地' || sessionStorage.getItem('orgType') ==='中转仓'){
      this.show = true
    }
    if(sessionStorage.getItem('orgType') ==='中转仓'){
      this.flag1 = true
      // this.getThree();
    }else if(sessionStorage.getItem('orgType') ==='物流基地'){
      this.flag = true
      // this.getBellleft();
      // this.getBellright();
    }
  },
  methods: {
    tuichu() {
      this.axios({
        method:'get',
        url: "/les/system/user/loginOut",
      }).then(res=>{
        console.log(res,"退出登录");
        if(res.data === true){
          this.$router.replace("/");
          sessionStorage.clear();//清空sessionStorage中的值
        }
      })
    },
    // getBellleft(){
    //   // this.getInte()
    //   this.timeOne = setInterval(()=>{
    //     // this.getInte()
    //   },3600000)
    // },
    // getInte(){
    //   this.axios({
    //     method:'post',
    //     url:'/les/basics/interface/testPush',
    //     params:{
    //       userName:this.userBell,
    //       organizationCode:this.organizationCode,
    //       carriersCode:this.carriersBell,
    //     }
    //   }).then(res=>{
    //     res.data.forEach((item,index)=>{
    //       this.leftData.push({
    //         Rosy:item,
    //       })
    //     })
    //   })
    // },
    // getBellright(){
    //     this.axios({
    //       method:'post',
    //       url:'/les/basics/interface/checkGxNotFH',
    //       params:{
    //         userName:this.userBell,
    //         organizationCode:this.organizationCode,
    //       }
    //     }).then(res=>{
    //       res.data.forEach((item,index)=>{
    //         this.rightData.push({
    //           Luo:item,
    //         })
    //       })
    //     })
    // },
    // getThree(){
    //   this.axios({
    //     method:'post',
    //     url:'/les/basics/interface/checkZxNotFH',
    //     params:{
    //       userName:this.userBell,
    //       organizationCode:this.organizationCode,
    //     }
    //   }).then((res)=>{
    //     res.data.forEach((item,index)=>{
    //       this.threeData.push({
    //         jie:item,
    //       })
    //     })
    //   })
    // }
  },
  beforeDestroy() {
    clearInterval(this.timeOne)
    this.timeOne = null
  }
};
</script>

<style scoped lang="less">
.box {
  width: 100%;
  height: 60px;
  margin: 0 auto;
  clear: both;
}
.box-zhong {
  width: 220px;
  height: 60px;
  line-height: 60px;
  font-size: 21px;
  color: #333333;
  float: left;
  margin-left: 15px;
}
.box-right {
  float: right;
  height: 60px;
  line-height: 60px;
}
.box-right ::v-deep .el-icon-message-solid {
  font-size: 20px;
  margin-right: 30px;
  cursor: pointer;
}
.box-right ::v-deep .el-icon-s-custom {
  font-size: 20px;
  margin-right: 8px;
  cursor: pointer;
}
.box-right .Hello {
  font-size: 18px;
  margin-right: 8px;
  cursor: pointer;
}
.box-right ::v-deep .icon-tuichu1 {
  font-size: 20px !important;
  margin-right: 8px;
  color: black;
  cursor: pointer;
}
.Bell_reminder {
  clear: both;
}
.bell_left {
 float: left;
  width: 200px;
  text-align: center;
}
.bell-right {
  float: right;
  width: 200px;
  text-align: center;
}
</style>
